import Vue from 'vue'
import Router from 'vue-router'
import $vuex from '@/store'
import login from './login'
import menu from './menu'
import permissions from './permissions'
import roles from './roles'
import user from './user'
import setting from './setting'
import carousel from './carousel'
import link from './link'
import category from './category'
import article from './article'
import live from './live'
import lecturer from './lecturer'
import statistics from './statistics'
import attachment from './attachment'
import sysLog from './sys_log'
import company from './company'
import openapiServer from './openapi_server'
import wsAccount from './ws_account'
import settlement from './settlement'
import bill from './bill.js'
import account from './account.js'
import review from './review.js'
import inventory from './inventory.js'
import signer from './signer.js'
import statement from './statement.js'
import information from './information.js'
import contract from './contract.js'
import bindaccount from './bindaccount.js'
import invoicePartner from './invoice_partner.js'
import agreement from './agreement.js'
import audit from './audit.js'
import home from './home.js'
import preview from './preview.js'
import system from './system.js'
import announce from './announce.js'
import channel from './channel.js'
import api_merchant from './api_merchant'
import oem from './oem.js'
import storage from '@/utils/localstorage'
import buser from './buser'
import issuing_agent from './issuing_agent'
import individual from './individual'
import channelrebate from "./channelrebate"
import Invoicing from './Invoicing'
import paihuo from './paihuo.js'
import paihuo_project from './paihuo_project.js'
import recharge from './recharge.js'
import pay_manage from './pay_manage.js'
import data_analysis from './data_analysis.js'//数据统计
import questionnaire from './questionnaire.js'//调查问卷
import declare_list from './declare_list.js'

import without_card from './without_card.js' //无卡发薪

import {operator,operator_package} from './operator_manage.js' //运营商管理
import activeData from './activeData.js' //活跃数据
import sales_manage from './sales_manage.js' //销售管理
import share_sales from './share_sales.js' //销售端
// 解决vue报错vue-router.esm.js
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

// 路由详情
const routes = [{
		path: '/',
		component: () => import('@/layouts/BasicLayout'),
		meta: {
			title: '首页'
		},
		hidden: true,
		children: [
      operator_package,//套餐详情
      operator,//运营商管理
      without_card,//无卡发薪
      questionnaire,//问卷调查
      declare_list,//配置个税信息
      pay_manage,
			home, //首页
			menu, // 菜单
			permissions, // 权限
			roles, // 角色
			user, // 用户
			setting, // 基础设置
			carousel, // 轮播图
			link, // 友情链接
			category, // 分类管理
			article, // 文章管理
			live, // 直播管理
			lecturer, // 讲师管理
			statistics, // 统计管理
			attachment, // 附件管理
			sysLog, // 系统日志
			company, // 公司管理
			openapiServer, // 开放平台配置管理
			wsAccount, // 网商子账号
			settlement, // 银行中心->账户资料
			bill, //结算清单管理
			review, //结算审核
			account, //账号管理
			inventory, //结算单记录
			signer, //签约人员查看
			statement, //结算单记录
			information, //账号信息
			contract, //绑定合同
			bindaccount, //绑定账号
			invoicePartner, //开票管理
			Invoicing, //发票代开
			audit, //各种审核
			preview, //各种预览
			system, //后台公告
			announce, //公告管理
			oem, //oem申请
			channel, //渠道商户
			api_merchant, //api商户
			buser, //b端用户管理
			issuing_agent, //代开
			individual,
			channelrebate, //渠道返佣
			paihuo, // 派活
			paihuo_project, // 派活项目
			recharge,//预充值
			data_analysis,//数据统计
			activeData,//活跃数据
			sales_manage,//销售管理
			share_sales,//销售端
			{
				path: 'exception/404',
				component: () => import( /* webpackChunkName: "exception-404" */ '@/pages/exception/404')
			}
		]
	},
	{
		path: '/',
		component: () => import('@/layouts/PassportLayout'),
		children: [
			login, // 登录
		]
	},
	{
		path: '/',
		component: () => import('@/layouts/ContractLayout'),
		children: [
			agreement, // 合同
		]
	},
	{
		path: "*",
		redirect: '/exception/404',
		// component: () => import('@/pages/exception/404')
	}
]

// 实例化
const router = new Router({
	base: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/',
	mode: 'history',
	routes
})

// 路由钩子
router.beforeEach((to, from, next) => {
	ifLogin(to, next)
	handelSiderMenu(to)
	next()
});

/**
 * @description 处理左侧菜单的选中
 * @author YM
 * @date 2019-01-10
 * @param {*} to 当前路由
 */
let handelSiderMenu = (to) => {
	$vuex.commit('handleRoutePath', to.path)
}

/**
 * @description 处理左侧菜单的选中
 * @author YM
 * @date 2019-01-10
 * @param {*} to 当前路由
 * @param {*} next 回调函数
 */
let ifLogin = (to, next) => {
	let userInfo = storage.get('user_info')
	// 判断是否是登录页
	let idx = to.path.indexOf('login') != -1
	// 没有userInfo 且 不是login 页 => 登录页
	if (!userInfo && !idx) {
		next('/login')
	}
	// 有userinfo 且 是login 页 => 首页
	if (idx && userInfo) {
		next('/')
	}
}

export default router
